<div class="main-content" id="main-content" *ngIf="!error; else errorMsg">
  <section id="breadcrumbs">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <!-- <div class="br-breadcrumb">
                  <ul class="crumb-list">
                     <li class="crumb home">
                        <a class="br-button circle" [routerLink]="['/']">
                           <span class="sr-only">Página inicial</span>
                           <i class="fas fa-home"></i>
                        </a>
                     </li>
                     <li class="crumb">
                        <i class="icon fas fa-chevron-right"></i>
                        <a [routerLink]="['/cursos']">Todos os Cursos</a>
                     </li>
                     <li class="crumb">
                        <i class="icon fas fa-chevron-right"></i>
                        <a
                           [routerLink]="['/eixo-tecnologico']"
                           [queryParams]="{ id: eixo.id }"
                        >
                           {{ eixo.nome }}</a
                        >
                     </li>
                     <li class="crumb" data-active="active">
                        <i class="icon fas fa-chevron-right"></i>
                        <span>{{ area.nome }}</span>
                     </li>
                  </ul>
               </div> -->
          <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
        </div>
      </div>
    </div>
  </section>

  <section id="page">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div id="page-header">
            <div id="page-title" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h2>{{ area.nome }}</h2>
                <p *ngIf="totalResultados">
                  Total de resultados encontrados
                  {{ totalResultados }}
                </p>
                <p *ngIf="!totalResultados">
                  Desculpe, não encontramos nenhum resultado compatível com a
                  busca.
                </p>
              </div>
            </div>
            <div id="results">
              <div class="row articles">
                <div
                  class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                  *ngFor="let curso of cursos"
                >
                  <app-card
                    [titulo]="curso.nome"
                    [texto]="curso.perfilProfissional || curso.nomeCursoAtual"
                    [id]="curso.idCursoAtual || curso.id"
                    [eixo]="curso.eixoId || curso.eixoId"
                    [eixos]="eixos"
                    [cursoAtual]="curso.nomeCursoAtual"
                    [eixoNome]="curso.eixo"
                    [tipo]="curso.status"
                  >
                  </app-card>
                </div>
              </div>
            </div>
            <app-paginacao
              *ngIf="totalResultados"
              [paginaAtual]="paginaAtual"
              [totalPaginas]="totalPaginas"
              (mudouPagina)="onPaginaSelecionada($event)"
            >
            </app-paginacao>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #errorMsg> </ng-template>
